
const digest = 'bbcee2aa361bd162c995836c5562d4b6dbc4b14f4a354a3f1d2755c6fbf400f0';
const classes = {"field":"_field_w2hra_1","apgarContainer":"_apgar-container_w2hra_5","apgarSplitter":"_apgar-splitter_w2hra_9"};
const css = `._field_w2hra_1 {
  margin-bottom: 10px;
}

._apgar-container_w2hra_5 {
  display: flex;
  flex-direction: row;
}
._apgar-splitter_w2hra_9 {
  margin: 0 15px;
  display: flex;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  